import React, { Component } from "react";
import PropTypes from "prop-types";

import LineSeries from "./LineSeries";
import StaticAreaSeries from "./StaticAreaSeries";

class BollingerSeries extends Component {
  constructor(props) {
    super(props);
    this.yAccessorForTop = this.yAccessorForTop.bind(this);
    this.yAccessorForMiddle = this.yAccessorForMiddle.bind(this);
    this.yAccessorForBottom = this.yAccessorForBottom.bind(this);
    this.yAccessorForScalledBottom = this.yAccessorForScalledBottom.bind(this);
  }
  yAccessorForTop(d) {
    const { yAccessor } = this.props;
    return yAccessor(d) && yAccessor(d).top;
  }
  yAccessorForMiddle(d) {
    const { yAccessor } = this.props;
    return yAccessor(d) && yAccessor(d).middle;
  }
  yAccessorForBottom(d) {
    const { yAccessor } = this.props;
    return yAccessor(d) && yAccessor(d).bottom;
  }
  yAccessorForScalledBottom(scale, d) {
    const { yAccessor } = this.props;
    return scale(yAccessor(d) && yAccessor(d).bottom);
  }
  render() {
    const { areaClassName, className, onDoubleClick, onContextMenu } =
      this.props;
    const { strokeTop, strokeMiddle, strokeBottom, fill } = this.props;

    return (
      <g className={className} style={{ cursor: "pointer" }}>
        <LineSeries
          yAccessor={this.yAccessorForTop}
          stroke={strokeTop}
          fill="none"
          highlightOnHover
          onDoubleClick={onDoubleClick}
          onContextMenu={onContextMenu}
        />
        <LineSeries
          yAccessor={this.yAccessorForMiddle}
          stroke={strokeMiddle}
          fill="none"
          highlightOnHover
          onDoubleClick={onDoubleClick}
          onContextMenu={onContextMenu}
        />
        <LineSeries
          yAccessor={this.yAccessorForBottom}
          stroke={strokeBottom}
          fill="none"
          highlightOnHover
          onDoubleClick={onDoubleClick}
          onContextMenu={onContextMenu}
        />
        <StaticAreaSeries
          className={areaClassName}
          yAccessor={this.yAccessorForTop}
          base={this.yAccessorForScalledBottom}
          stroke="none"
          fill={fill.color}
          opacity={fill.opacity}
        />
      </g>
    );
  }
}

BollingerSeries.propTypes = {
  yAccessor: PropTypes.func.isRequired,
  className: PropTypes.string,
  areaClassName: PropTypes.string,
  type: PropTypes.string,
  strokeTop: PropTypes.object.isRequired,
  strokeMiddle: PropTypes.object.isRequired,
  strokeBottom: PropTypes.object.isRequired,
  fill: PropTypes.object.isRequired,
  onDoubleClick: PropTypes.func,
  onContextMenu: PropTypes.func,
};

BollingerSeries.defaultProps = {
  className: "react-stockcharts-bollinger-band-series",
  areaClassName: "react-stockcharts-bollinger-band-series-area",
  strokeTop: { color: "#964B00" },
  strokeMiddle: { color: "#FF0000" },
  strokeBottom: { color: "#964B00" },
  fill: { color: "#4682B4", opacity: 0.2 },
};

export default BollingerSeries;
